/* export const Url = 'https://www.iudlm.com.ve/api/';
export const UrlImg = 'https://www.iudlm.com.ve/img_system/'; */


/* export const Url = 'https://sistema.iudlm.com.ve/api/';
export const UrlImg = 'https://sistema.iudlm.com.ve/img_system/'; */

/* export const Url = 'http://localhost/tad_backend/public/api/';
export const UrlImg = 'http://localhost/tad_backend/public/img_system/'; */

export const Url = 'https://pruebas.edueyss.com/api/';
export const UrlImg = 'https://pruebas.edueyss.com/img_system/';

/* export const Url = 'http://192.168.1.51/api/';
export const UrlImg = 'http://192.168.1.51/img_system/'; */

/* export const Url = 'http://institutodemo.edueyss.com/api/';
export const UrlImg = 'http://institutodemo.edueyss.com/img_system/'; */


/* var formdata = new FormData();
formdata.append("fecha", "2023-04-06");
formdata.append("status", "0");
formdata.append("secure", "iudlm2023@");

var requestOptions = {
  method: 'POST',
  body: formdata,
  redirect: 'follow'
};

fetch("http://localhost/u-edueyss/public/api/CreateHsh", requestOptions)
  .then(response => response.text())
  .then(result => console.log(result))
  .catch(error => console.log('error', error));


var formdata = new FormData();
formdata.append("fecha", "2023-04-06");
formdata.append("status", "0");
formdata.append("secure", "U_EDUEYSS");
formdata.append("key", "$5$$T4ZJZoXGVQj7yukia8Dnqri9FPn0sRlNpeOBA4U.sa3");

var requestOptions = {
  method: 'POST',
  body: formdata,
  redirect: 'follow'
};

fetch("http://localhost/u-edueyss/public/api/AddHsh", requestOptions)
  .then(response => response.text())
  .then(result => console.log(result))
  .catch(error => console.log('error', error)); */


// WEBPACK FOOTER //
// ./src/shared/Url.jsx